import { useAuth } from '../store/AuthContext';
import {
  AdminModule,
  canAccessModule,
  canCreate,
  canDelete,
  canEdit,
  getResolvedPermissions,
} from '../utils/adminPermissions';

export const useAdminPermission = () => {
  const { authState } = useAuth();
  const permissions = getResolvedPermissions(authState);

  return {
    role: authState.role,
    department: authState.department,
    permissions,
    canView: (module: AdminModule) => canAccessModule(permissions, module, 'view'),
    canCreate: (module?: AdminModule) =>
      module ? canAccessModule(permissions, module, 'create') : canCreate(permissions),
    canEdit: (module?: AdminModule) =>
      module ? canAccessModule(permissions, module, 'edit') : canEdit(permissions),
    canDelete: (module?: AdminModule) =>
      module ? canAccessModule(permissions, module, 'delete') : canDelete(permissions),
    isFounder: authState.role === 'FOUNDER',
  };
};
